<div>
    <div class="row" [formGroup]="form">
        <div class="col-12">
            <div class="row">
                <div class="col">
                    <mat-label class="font-style" [ngbTooltip]="pipeSize_tooltip" placement="right" container="body" tooltipClass="small-tooltip">
                        <!-- Pipe Size -->
                        {{ 'SETTING_PAGE.IDMS_SETTINGS.MINIMUM_PIPE_SIZE' | transloco }}
                    </mat-label>
                    <!--tool-tip template start-->
                    <ng-template #pipeSize_tooltip>
                        <p>
                            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.PIPE_SIZE' | transloco }}
                        </p>
                    </ng-template>
                    <!--tool-tip template end-->
                    <mat-select
                        class="dropdown-wrapper"
                        panelClass="dropdown-wrapper"
                        *ngIf="!isCustom"
                        formControlName="minPipeSize"
                        name="minPipeSize"
                        class="input-select"
                        [class.select-disable]="enable"
                    >
                        <mat-option class="option-list" *ngFor="let x of minoptionList" [value]="x.pipeSizeId">{{ x.pipeName }}</mat-option>
                    </mat-select>
                </div>
                <div class="col">
                    <mat-label class="font-style" [ngbTooltip]="pipeSize_tooltip" placement="right" container="body" tooltipClass="small-tooltip">
                        <!-- Pipe Size -->
                        {{ 'SETTING_PAGE.IDMS_SETTINGS.MAXIMUM_PIPE_SIZE' | transloco }}
                    </mat-label>
                    <!--tool-tip template start-->
                    <ng-template #pipeSize_tooltip>
                        <p>
                            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.PIPE_SIZE' | transloco }}
                        </p>
                    </ng-template>
                    <!--tool-tip template end-->
                    <mat-select
                        class="dropdown-wrapper"
                        panelClass="dropdown-wrapper"
                        *ngIf="!isCustom"
                        formControlName="maxPipeSize"
                        name="maxPipeSize"
                        class="input-select"
                        [class.spinner]="loading"
                        [ngClass]="enable ? 'select-disable' : ''"
                    >
                        <mat-option class="option-list" *ngFor="let y of maxoptionList" [value]="y.pipeSizeId">{{ y.pipeName }}</mat-option>
                    </mat-select>
                </div>
            </div>
        </div>
    </div>
</div>
